import React from 'react';
import { CheckIcon } from 'lucide-react';
import { deliverables } from '../data/content';
export function Deliverables() {
  const [primary, ...rest] = deliverables;
  return <section aria-labelledby="incluye-titulo" className="w-full bg-white py-16 sm:py-24" data-id="element-31" data-mp="1e1puzhrc1lbz">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-32" data-mp="1e3kdkpf4t1cw">
        <h2 id="incluye-titulo" className="max-w-2xl font-display text-3xl font-extrabold uppercase leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-33" data-mp="199g9cdx937fi">
          Lo que recibes hoy mismo
        </h2>

        <div className="mt-10 grid gap-10 lg:grid-cols-[1fr_1fr] lg:gap-14" data-id="element-34" data-mp="1j36sr4eisroc">
          <div className="rounded-2xl bg-navy-900 p-8 text-white sm:p-10" data-id="element-35" data-mp="1wzsoo9uts6g4">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-ember-400" data-id="element-36" data-mp="1t01ojfjesdyx">
              Pieza central
            </p>
            <h3 className="mt-4 font-display text-2xl font-extrabold leading-tight sm:text-3xl" data-id="element-37" data-mp="2onfyr4vt3tx">
              {primary.title}
            </h3>
            <p className="mt-4 text-base leading-relaxed text-sand-100/80" data-id="element-38" data-mp="3k5vge3xk0dts">{primary.body}</p>
          </div>

          <ul className="space-y-6 self-center" data-id="element-39" data-mp="3p58ejktvl7bo">
            {rest.map(item => <li key={item.title} className="flex gap-4" data-id="element-40" data-mp="3u2rv4re1pw6s">
                <CheckIcon aria-hidden="true" className="mt-1 h-5 w-5 shrink-0 text-ember-600" strokeWidth={3} data-id="element-41" data-mp="3u170l1rqed8x" />
                <div data-id="element-42" data-mp="7nfg8bgpgnqm">
                  <h3 className="font-display text-lg font-bold text-ink" data-id="element-43" data-mp="7q1jw00h6j3k">{item.title}</h3>
                  <p className="mt-1 text-base leading-relaxed text-ink/70" data-id="element-44" data-mp="brdc8daqhifg">{item.body}</p>
                </div>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}